import { render, staticRenderFns } from "./RiskPermitWorkDoc.vue?vue&type=template&id=3a828c05&scoped=true&"
import script from "./RiskPermitWorkDoc.vue?vue&type=script&lang=js&"
export * from "./RiskPermitWorkDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a828c05",
  null
  
)

export default component.exports